import React, { useState } from 'react';
import classes from './ImageViewer.module.css';

const ImageViewer = ({ data ,contentDirPath=''}) => {
    return <div className={classes.ImageViewer} style={data && data ?{ backgroundImage: `url(${contentDirPath}${data.url})`,...data}:{}}> 
    {/* <img className={classes.ImageViewer} src={data}  */}
    </div>
}
export default ImageViewer;